import styled from '@emotion/styled';
import { Grid, Typography, useMediaQuery } from '@material-ui/core';
import { createElement, Fragment } from 'react';

import { SearchAssetResult } from '../../../../entity/SearchAsset';
import theme from '../../../../theme';

type Props = {
  previewAsset: SearchAssetResult[number] | null;
};

export const AudioPreview = ({ previewAsset }: Props) => {
  const isPC = useMediaQuery(`(min-width:${theme.breakpoints.values['lg']}px)`);

  return (
    <>
      {previewAsset && previewAsset.type === 'audio' && (
        <Grid item style={{ textAlign: isPC ? 'center' : 'left' }}>
          <Audio src={previewAsset.lightWeightUrl || previewAsset.originalUrl} controls={true} />
          <TypographyName>{previewAsset.displayName}</TypographyName>
        </Grid>
      )}
    </>
  );
};

const Audio = styled('audio')`
  outline: none;
`;

const TypographyName = styled(Typography)`
  margin-bottom: 5px;
  ${theme.breakpoints.down('sm')} {
    margin: 5px 5px 8px 5px;
    text-align: left;
  }
`;
